import styled from 'styled-components';

export const ListingDetailContainer = styled.div`
  align-items: start;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px;
  padding-top: 24px;
  width: 100%;
`;

export const Header = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const HeaderLeftContent = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const BodyContent = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
`;

export const BodyLeftContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 33%;
`;

export const InventoryDetailContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 33%;
`;

export const OverviewDetailContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 33%;
`;

export const OverviewTitle = styled.h4`
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  font-weight: 600;
  margin: 0;
`;

export const InventorySelectionDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.04);
`;

export const QtyTicker = styled.div`
  align-items: center;
  display: flex;
  gap: 10px;
`;

export const QtyButton = styled.button`
  align-items: center;
  background: transparent;
  border: none;
  cursor: ${props => props.$disabled ? 'not-allowed' : 'pointer'};
  display: flex;
  height: 24px;
  justify-content: center;
  opacity: ${props => props.$disabled ? 0.3 : 1};
  padding: 0;
  width: 24px;

  img {
    height: 14px;
    width: 14px;
  }
`;

export const QtyValue = styled.span`
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 600;
  min-width: 24px;
  text-align: center;
`;

export const CostRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`;

export const CostLabel = styled.span`
  color: rgba(255, 255, 255, 0.6);
  font-size: 12px;
  font-weight: 500;
`;

export const CostValue = styled.span`
  color: rgba(255, 255, 255, 0.9);
  font-size: 13px;
  font-weight: 600;
`;

export const ListingTitle = styled.h3`
  font-size: 24px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;
`;

export const HeaderRightContent = styled.div`
  align-items: center;
  display: flex;
  gap: 16px;
`;
export const StatusControl = styled.div`
  align-items: center;
  background: ${({ $sold }) => ($sold ? 'rgba(40, 167, 69, 0.14)' : 'rgba(255, 255, 255, 0.06)')};
  border: 1px solid ${({ $sold }) => ($sold ? 'rgba(40, 167, 69, 0.5)' : 'rgba(255, 255, 255, 0.2)')};
  border-radius: 8px;
  display: flex;
  padding: 0px 4px;

  select {
    color: ${({ $sold }) => ($sold ? '#8FD79F' : 'rgba(255, 255, 255, 0.9)')};
    font-weight: 600;
  }
`;

export const MetaStrip = styled.div`
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  padding-bottom: 16px;
  width: 100%;
`;

export const MetaItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const MetaLabel = styled.span`
  color: rgba(255, 255, 255, 0.45);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.4px;
  text-transform: uppercase;
`;

export const MetaValue = styled.span`
  color: rgba(255, 255, 255, 0.85);
  font-size: 13px;
  font-weight: 500;
`;

export const CopyableMetaValue = styled(MetaValue)`
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  font-family: inherit;
  gap: 6px;
  padding: 0;
  text-align: left;

  &:hover {
    color: #FFFFFF;
  }

  span {
    color: rgba(255, 255, 255, 0.4);
    font-size: 10px;
    text-transform: uppercase;
  }
`;

export const StatusPill = styled.span`
  background: ${({ $sold }) => ($sold ? 'rgba(40, 167, 69, 0.18)' : 'rgba(255, 255, 255, 0.1)')};
  border: 1px solid ${({ $sold }) => ($sold ? 'rgba(40, 167, 69, 0.5)' : 'rgba(255, 255, 255, 0.2)')};
  border-radius: 4px;
  color: ${({ $sold }) => ($sold ? '#8FD79F' : 'rgba(255, 255, 255, 0.85)')};
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.4px;
  padding: 3px 8px;
  text-transform: uppercase;
  white-space: nowrap;
`;

export const ConfirmMessage = styled.span`
  color: #FFC661;
  font-size: 12px;
  font-weight: 500;
  max-width: 420px;
  text-align: right;
`;

export const ListingStats = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
  font-weight: 500;
`;

export const LoadingSpinner = styled.div`
  color: #FFFFFF;
  text-align: center;
  padding: 40px;
  font-size: 16px;
`;

export const ErrorMessage = styled.div`
  color: #ff6b6b;
  text-align: center;
  padding: 20px;
  font-size: 14px;
  background: rgba(255, 107, 107, 0.1);
  border: 1px solid rgba(255, 107, 107, 0.3);
  border-radius: 8px;
`;

export const EmptyState = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 214px;
  background: rgba(255, 255, 255, 0.05);
  border: 2px dashed rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  gap: 16px;
  width: 100%;

  p {
    color: rgba(255, 255, 255, 0.6);
    font-size: 13px;
    margin: -8px 0 0;
  }
`;

export const ListingDescription = styled.div`
  margin: 8px 0px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  p {
    color: rgba(255, 255, 255, 0.8);
    font-size: 14px;
    margin: 0;
    line-height: 1.5;
  }
`;

export const DatePill = styled.div`
  align-items: center;
  border: 2px solid rgba(255, 255, 255, 0.33);
  border-radius: 100px;
  cursor: pointer;
  display: flex;
  gap: 8px;
  height: 40px;
  padding: 0px 20px;
  transition: 0.4s;

  h5 {
    color: rgba(255, 255, 255, 0.8);
    font-size: 12px;
    font-weight: 500;
    margin: 0;
  }
`;

export const InfoRow = styled.div`
  display: flex;
  gap: 8px;
`;



